import { render, staticRenderFns } from "./InjuryDetails.vue?vue&type=template&id=4a0795c4"
import script from "./InjuryDetails.vue?vue&type=script&lang=js"
export * from "./InjuryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports